import { render, staticRenderFns } from "./ConfirmExit.vue?vue&type=template&id=6540ad24&"
import script from "./ConfirmExit.vue?vue&type=script&lang=js&"
export * from "./ConfirmExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports